import {ChangeDetectorRef, Component, Input, ViewChild} from '@angular/core';
import {animateShow} from "../../animations/showHideAnimation";
import {GroupService} from "../../services/groupService/group-service.service";
import {ItemManagerService} from "../../services/itemManager/item-manager.service";
import {AbstractObserver} from "../../classes/AbstractObserver/AbstractObserver";
import {ConcreteLayerService} from "../../services/concreteLayer/concrete-layer.service";
import {DomEventsService} from "../../services/dom-event-services/dom-events.service";
import {GroupDomService} from "../../services/groupDOMService/group-dom.service";
import {filter} from "rxjs/operators";

@Component({
  selector: 'app-group-sidebar',
  templateUrl: './group-sidebar.component.html',
  styleUrls: ['./group-sidebar.component.scss'],
  animations: [animateShow]
})
export class GroupSidebarComponent extends AbstractObserver{

  @Input() disabled = false;
  @ViewChild('element', {static: false}) element;
  public isGroupActionsVisible = false;
  public isMultiSelectMoveAvailable = false;
  public Yiit = Yiit;
  public isGroupListVisible = false;
  private selectedItemsByMultiSelect = {};

  constructor(private cd: ChangeDetectorRef, private gs: GroupService, private im: ItemManagerService, private cs: ConcreteLayerService, private domEvents: DomEventsService) {
    super();
    this.subscribeToObservable(this.im.selectedItemList$, (config)=>{
      this.isMultiSelectMoveAvailable = Object.keys(config).length > 1;
      this.selectedItemsByMultiSelect = config;
      this.cd.detectChanges();
    });

    this.subscribeToObservable(this.domEvents.sidebarState$.pipe(filter(val=> !val && (this.isGroupActionsVisible || this.isGroupListVisible))), (val)=>{
      this.isGroupActionsVisible = false;
      this.isGroupListVisible = false;
      this.domEvents.currentActiveAdditionalMenuElement = null;
      this.cd.detectChanges();
    });

    // @ts-ignore
    this.subscribeToObservable(this.domEvents.currentHiddenMenuUpdated$.pipe(filter(value => { return value.type !== 'other'})), ()=>{
      this.isGroupActionsVisible = false;
      this.cd.detectChanges();
    })
  }

  getAllGroups(){
    let gList = this.gs.groupList.slice(0);
    gList = gList.filter((group)=>{
      return group.getFloorPlanId() == this.cs.selectedConcrete.id;
    });
    return gList;
  }

  hasAnotherGroup(){
    let gList = this.gs.groupList.slice(0);
    return gList.filter((group)=>{
      return group.getFloorPlanId() == this.cs.selectedConcrete.id;
    }).length > 1;
  }

  toggleGroupActionsVisibility(){
    if (this.disabled) { return; }

    this.isGroupActionsVisible = !this.isGroupActionsVisible;
    if (this.isGroupActionsVisible){
      this.domEvents.currentHiddenMenuUpdated$ = {type: 'other', item: null};
      this.cd.detectChanges();
      this.domEvents.currentActiveAdditionalMenuElement = this.element;
    }
    else{
      this.domEvents.currentActiveAdditionalMenuElement = null;
    }
    this.cd.detectChanges();
  }

  public createNewGroup() {
    const config = {title: this.Yiit.t('New Folder'), floorplan_id: this.cs.selectedConcrete.id};
    this.gs.createGroup(config);
  }

  public moveToGroup(group){
    if (!this.isMultiSelectMoveAvailable){
      return;
    }
    for (let i in this.selectedItemsByMultiSelect){
      let _item = this.selectedItemsByMultiSelect[i];
      this.gs.moveToNewGroup(_item, group);
    }
    this.isGroupListVisible = false;
    this.cd.detectChanges()
  }

  setGroupListVisibility(val: boolean){
    this.isGroupListVisible = val;
    this.cd.detectChanges();
  }
}
